
import { defineComponent, PropType } from 'vue'

interface PrimaryAction {
  label: string
  icon: string
  action: () => void
}

export default defineComponent({
  name: 'Toast',
  props: {
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    timeout: {
      type: Number,
      default: 2
    },
    autoClose: {
      type: Boolean,
      default: true
    },
    classToast: {
      type: String,
      default: 'bg-ink-200'
    },
    primary: {
      type: Object as PropType<PrimaryAction>,
      default: () => ({
        label: '',
        icon: '',
        action: () => {
          // Intentionally left empty default action
        }
      })
    }
  },

  data() {
    return {
      active: false,
      interval: null,
      timeLeft: 0,
      speed: 100
    }
  },

  mounted() {
    this.active = true
    if (this.timeout > 0 && this.autoClose) {
      this.timeLeft = this.timeout * 1000
      setTimeout(this.destroy, this.timeLeft)
    }
  },

  computed: {
    classToastAll(): Array<string> {
      if (this.classToast) return [this.classToast]
      return []
    }
  },
  methods: {
    removeElement(el: Element) {
      if (el) {
        if (typeof el.remove !== 'undefined') el.remove()
        else el.parentNode?.removeChild(el)
      }
    },
    destroy() {
      this.active = false
      setTimeout(() => {
        this.$destroy()
        this.removeElement(this.$el)
      }, 1000)
      this.$emit('destroy')
    },
    primaryAction() {
      this.destroy()
      this.primary.action()
    }
  }
})
